import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Box, Button, Drawer, IconButton, IconButtonProps, Tooltip } from '@mui/material'
import { Close, QuestionMark } from '@mui/icons-material'
import { setShowInstructions } from '../redux/slices/notifications'
import { RootState } from '../redux'
import { useUserManual } from '../contexts/userManual'
import ConfluencePageArticle from './ConfluencePageArticle'
import LoadingState from './LoadingState'

type InstructionsProps = Omit<IconButtonProps, 'onClick'>

export default function InstructionsButton(props: InstructionsProps) {
  /**
   * The translation function.
   */
  const [t] = useTranslation('common')

  /**
   * The dispatch fuunction
   */
  const dispatch = useDispatch()

  /**
   * The notification state.
   */
  const { showInstructions } = useSelector((state: RootState) => state.notifications)

  /**
   * The user manual state.
   */
  const userManual = useUserManual()

  /**
   * Show short instruction for the new user
   */
  useEffect(() => {
    dispatch(setShowInstructions(false))
  }, [])

  return (
    <>
      {userManual && (
        <Tooltip title={t('userManual') as string}>
          <IconButton {...props} onClick={() => dispatch(setShowInstructions(true))}>
            <QuestionMark fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}

      <Drawer
        anchor="right"
        open={showInstructions}
        onClose={() => dispatch(setShowInstructions(false))}
        PaperProps={{
          sx: {
            maxWidth: '320px',
            width: '100%',
            pt: 4,
            px: 2,
            pb: 2
          }
        }}
      >
        <Box position="relative" display="flex" flexDirection="column" height="100%">
          <Box height="100%" flexGrow={1}>
            {userManual ? (
              <>
                <IconButton
                  onClick={() => dispatch(setShowInstructions(false))}
                  sx={{ position: 'absolute', top: 0, right: 0 }}
                >
                  <Close />
                </IconButton>

                <ConfluencePageArticle page={userManual} />
              </>
            ) : (
              <LoadingState />
            )}
          </Box>

          <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 6 }}>
            <Button onClick={() => dispatch(setShowInstructions(false))} fullWidth>
              {t('close')}
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  )
}
